import { contentPropertyService } from "@Shared/Service/ContentPropertyService";

export const getUserById = async (id) =>
  new Promise((resolve) => {
    window.AP.request(`/rest/api/user?accountId=${id}`)
      .then((data) => {
        const user = JSON.parse(data.body);
        resolve({
          key: user.accountId,
          name: user.displayName,
          src: `${window.AP._hostOrigin}${user.profilePicture.path}`,
        });
      })
      .catch(() => {
        resolve(undefined);
      });
  });

export const getContentProperty = async (id) => {
  try {
    const contentProperty = await contentPropertyService.getContentProperty(
      `caelor-${id}`
    );
    return contentProperty;
  } catch (error) {
    return undefined;
  }
};

export const updateContentProperty = async (id, value, version) => {
  try {
    await contentPropertyService.updateContentProperty(id, value, version);
    return true;
  } catch (error) {
    return undefined;
  }
};
